/**
 * Adds Elevar Google Tag Manager data layer information as to whether the (add to bag) click:
 * - Was from PDP main product 'Add'
 * - Was from PDP Shop The Look product 'Add'
 * - Was from PLP Product card/grid: isPlpGridProduct is true
 * - Was from PLP Recently Viewed (editable in section settings)
 * - Was from PDP: You May Also Like (editable in section settings)
 * - Was from PDP: Recently Viewed (editable in section settings)
 * - Was from Shopping Bag (editable in section settings)
 * - Was from Wishlist (editable in section settings)
 *
 * @param {Object} options - The options for setting the data layer values.
 * @param {string|boolean} options.type - The type of the product. Can be 'default', 'shop-the-look', or false.
 * @param {boolean} options.isPlpProduct - Whether the product is a PLP product.
 * @param {Object|boolean} options.trackingParameters - The tracking parameters for the product.
 * @param {String|boolean} options.flexiFashion - The string of the active FlexiFashion instance.
 */
function setDataLayerValues({
  type = false,
  isPlpProduct = false,
  trackingParameters = false,
  flexiFashion = false,
} = false) {

  if (!window.ElevarDataLayer) {
    console.warn('window.ElevarDataLayer is not available. Data layer push failed.')
    return
  }

  const dataSourcePdpDefault = window.mint.services.elevarSources.pdpMainProduct
  const dataSourcePdpSTL = window.mint.services.elevarSources.pdpShopTheLook
  const dataSourcePlpGrid = window.mint.services.elevarSources.plpProductGrid

  let dataSource

  /**
   * PDP Main Product or Shop The Look.
   */
  if (type) {
    switch (type) {
      case 'default':
        dataSource = dataSourcePdpDefault
        break
      case 'shop-the-look':
        dataSource = dataSourcePdpSTL
        break
      default:
        console.error(`setDataLayerValues unexpected type: ${type}`)
        return
    }
  }
  else {

    /**
     * PLP product grid (isPlpProduct) or
     * You May Also Like / Recently Viewed / Wishlist via section setting value (trackingParameters).
     */
    dataSource = isPlpProduct ? dataSourcePlpGrid : trackingParameters
  }

  if (dataSource === undefined) {
    mint.Log('warning', 'Unexpected tracking parameters', false, {
      type, isPlpProduct, trackingParameters,
    })

    return
  }

  window.ElevarTransformFn = item => {
    const eventType = item?.event

    /**
     * Early return for events that are not add to cart.
     * - Checks the event ID as well as checking if the expected properties for
     *   an add to cart event are unavailable.
     * - The event will still fire, but the data source will not be included.
     */
    if (
      eventType !== 'dl_add_to_cart' ||
      !item?.ecommerce ||
      !item?.ecommerce?.add?.products
    ) {
      return item
    }

    return {
      ...item,
      ecommerce: {
        ...item.ecommerce,
        add: {
          ...item.ecommerce.add,
          products: item.ecommerce.add.products.map(product => ({
            ...product,
            data_source: dataSource,
            data_source_url: window.location.href,
            flexi_fashion: flexiFashion || null,
          })),
        },
      },
    }
  }
}

export default setDataLayerValues
